<template>
    <div v-for="(record, index) in lodash.get(data.useForm.modelRef, itemsKey)" :key="record.id || record._id">
        <Row align="middle" justify="center">
            <Col :xs="24">
                <TemplateBuilder
                    :rowProp="data.rowProp"
                    :useForm="data.useForm"
                    :fields="
                        createField({
                            props,
                            data: { ...data },
                            key: `${itemsKey}.${index}`,
                            items: lodash.get(data.useForm.modelRef, itemsKey),
                            initItems: lodash.get(data.useForm.initialModel, itemsKey),
                            isLoading,
                            record,
                            index,
                            itemsKey
                        })
                    "
                    :skeleton="isLoading"
                ></TemplateBuilder>
            </Col>
        </Row>
    </div>
    <div class="has-error" v-if="data.useForm?.validateInfos?.[itemsKey]?.validateStatus === 'error'">
        <div class="ant-form-explain">
            {{ data.useForm?.validateInfos?.[itemsKey]?.help }}
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive, watch } from "vue";
import { /*Card,*/ Row, Col } from "ant-design-vue";
import { state as stateApp } from "../../../../app.logic";
import { initData, isLoading, createField } from "./choice.logic";
import lodash from "lodash";

export default defineComponent({
    components: {
        // Card,
        Row,
        Col,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        // CIcon: defineAsyncComponent(() => import("../../../../components/icon/CIcon")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        dataProp: {},
        itemsKey: {},
        visible: { default: true },
        canCreate: {},
        canDelete: {},
        surveyQuestionKey: {}
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });

        const items = props.itemsKey ? lodash.get(data.useForm?.modelRef, props.itemsKey) : data.useForm?.modelRef
        watch(
            () => items?.length,
            () => initData({ props, data, refs }),
            { flush: "post" }
        );
        return { props, data, refs, isLoading, initData, createField, lodash };
    },
});
</script>